import React, { useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import InfoIcon from "@material-ui/icons/Info";
import CancelIcon from "@material-ui/icons/Cancel";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { toast } from "react-toastify";

const InfoEfi = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const backendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  const webhookUrl = `${backendUrl}/subscription/webhook`;

  const handleCopy = async (text, label) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(`${label} copiado!`);
    } catch {
      toast.error("Não foi possível copiar.");
    }
  };

  return (
    <div>
      <IconButton onClick={() => setOpen(true)} aria-label="Manual Gerencianet PIX">
        <InfoIcon style={{ color: "black" }} />
      </IconButton>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: theme.palette.background.paper,
            padding: "24px",
            borderRadius: "8px",
            outline: "none",
            maxWidth: "720px",
            width: "92%",
            maxHeight: "85vh",
            overflow: "auto",
            color: theme.palette.text.primary,
          }}
        >
          <IconButton
            style={{ position: "absolute", top: "8px", right: "8px" }}
            onClick={() => setOpen(false)}
          >
            <CancelIcon />
          </IconButton>

          <Typography variant="h5" gutterBottom>
            Manual — Gerencianet / Efí (PIX)
          </Typography>

          <Typography variant="body2" color="textSecondary" paragraph>
            Cobrança PIX imediata por fatura, com reuso da mesma cobrança enquanto estiver ativa.
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>1. Credenciais</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            Configure <strong>Client ID</strong>, <strong>Client Secret</strong>,{" "}
            <strong>Chave PIX</strong> e envie o certificado <strong>.p12</strong> em{" "}
            Opções &gt; Cobrança (seção Gerencianet Efí). O ambiente sandbox usa{" "}
            <code>homologacao.p12</code>; produção usa <code>producao.p12</code>.
            Variáveis do <code>.env</code> ainda funcionam como fallback.
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>2. Webhook PIX</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            Cadastre no painel Efí/Gerencianet a URL:
          </Typography>
          <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
            <code style={{ wordBreak: "break-all", flex: 1 }}>{webhookUrl}</code>
            <Button
              size="small"
              variant="outlined"
              startIcon={<FileCopyIcon />}
              onClick={() => handleCopy(webhookUrl, "URL do webhook")}
            >
              Copiar
            </Button>
          </div>

          <Typography variant="body2" paragraph style={{ marginTop: 16 }}>
            Eventos PIX recebidos renovam a licença (+30 dias) via{" "}
            <code>renewCompanyAfterPayment</code>, igual Asaas e Mercado Pago.
          </Typography>
        </div>
      </Modal>
    </div>
  );
};

export default InfoEfi;
